import * as React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HeadProvider } from "react-head";

import "./utils/silenceConsoleNoise";
import App from "./App";
import { getReducedConfig } from "./utils/getReducedConfig";

const preloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

if (!preloadedState) {
  throw new Error("Missing window.__PRELOADED_STATE__");
}

const container = document.getElementById("root")!!;
const clientConfig = getReducedConfig(preloadedState.data);
const app = (
  <BrowserRouter>
    <HeadProvider>
      <App config={clientConfig} />
    </HeadProvider>
  </BrowserRouter>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
